import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import React from 'react';

type CheckboxSelectionProps = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  label: string;
  className?: string;
  disabled?: boolean;
};

const CheckboxSelection = (props: CheckboxSelectionProps) => {
  const { onChange, checked, label, className, disabled } = props;
  return (
    <FormGroup>
      <FormControlLabel
                control={
                  <Checkbox
                    className={`checkbox_${className}`}
                    color="primary"
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                  />
                }        
        label={label}
      />
    </FormGroup>
  );
};
export default CheckboxSelection;
